<template>
  <div>
    <h5 class="text-center">
      {{ computeCaption(fields_en['select_date_time'], this.$store.state.lang.value.toLowerCase()) }}</h5>
    <div class="row schedule" :class="[generalClass, validatedSectionClass]" style="padding-bottom: 30px">
        <div class="col-xs-12 col-md-4 el-col-md-offset-2">
          <DatePicker @chosenDate="chosenDate" :blockedDates="blockedDates" :disabledDayNames="disabledDayNames"/>
        </div>
        <div class="col-md-6 el-col-md-offset-1 right-schedule">
          <div>
            <div>
              <p> {{ computeCaption(fields_en['select_time'], this.$store.state.lang.value.toLowerCase()) }}</p>
              <br/>
              <div class="row">
                <div class="col-xs-12 col-md-12 col-sm-12">
                  <el-radio-group
                    size="medium"
                    :name="'dayTime'"
                    v-model="time.name"
                    @change="setId(time)"
                  >
                    <el-radio-button v-for="(time, index) in dayTimes" :value="time" :label="time.name"
                                     :disabled="loading || checkDisabledInterval(index) || checkBlockedDate(index)
                             || checkDateAvailability(index) || chosen === '' ? true : false"
                                     :key="time.id">
                    </el-radio-button>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
          <p class="address">Office location: <br>
            <a :href="'https://www.google.com/maps/search/?api=1&query=' + formattedAddress" target="_blank" title="Map Location">{{siteAddress}} </a>
          </p>
          <p class="text-center chosenDate" v-if="chosen">{{ date_text_display }}</p>
          <p v-else class="text-center chosenDate">
            {{ computeCaption(fields_en['no_time_date_selected'], this.$store.state.lang.value.toLowerCase()) }}</p>
          <br/>
          <small class="text-danger chosenDate" v-if="submit && (!time.name || !chosen)">
            {{ computeCaption(fields_en['please_choose'], this.$store.state.lang.value.toLowerCase()) }}</small>
        </div>
      </div>
  </div>
</template>

<script>
import {Input, Button, RadioGroup, Radio, RadioButton} from 'element-ui'
import {TranslationsUtils} from '../../../../utils/Translations'
import DatePicker from './DatePicker'
import {AccessionUtils} from '../../../../utils/AccessionDetailsProcessing'
import axios from 'axios'
import {PatientInfoUtils} from '../../../../utils/PatientInfo'
export default {
  name: 'ScheduleSection',
  props: ['configuration'],
  components: {
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Button.name]: Button,
    DatePicker
  },
  mixins: [
    TranslationsUtils,
    AccessionUtils,
    PatientInfoUtils
  ],
  data () {
    return {
      generalClass: 'general-inactive-section',
      validatedSectionClass: '',
      singlePage: this.$store.state.configs.SINGLE_PAGE_ORDERS || '',
      dayTimes: [],
      time: {name: '', id: ''},
      chosen: '',
      selectedDate: '',
      loading: false,
      submit: false,
      siteAddress: '',
      blockedDates: [],
      disabledDayNames: [],
      fields_en: {
        select_time: 'Please Select a Time*',
        select_date_time: 'Please select a date and time',
        confirm: 'Confirm',
        please_choose: 'Please choose a date and a time!',
        no_time_date_selected: 'No date or time selected yet.'
      }
    }
  },
  async beforeMount () {
    this.blockedDates = this.$store.state.site.schedule.blocked_days['blocked_days']
    this.disabledDayNames = this.$store.state.site.schedule.blocked_days['disabled_day_names']
    this.$store.state.site.schedule.data.map((value, i) => {
      this.dayTimes.push({name: value.name, id: value.id})
    })
    this.siteAddress = this.$store.state.site.address
  },
  methods: {
    setId (val) {
      let id
      for (id in this.dayTimes) {
        if (this.dayTimes[id]['name'] === val.name) {
          this.time.id = this.dayTimes[id]['id']
        }
      }
    },
    async validate () {
      let info = await this.getPatientInfo()
      this.submit = true
      let schedule = {appointment_date: this.selectedDate, appointment_slot_id: this.time.id, info: info}
      let token = localStorage.getItem('token')
      // check if the selected interval exceeds the capacity limit
      let resp
      if (schedule.appointment_slot_id && schedule.appointment_date) {
        await axios.post(process.env.SERVER_URI + '/check_schedule/' + this.$store.state.sitecode, schedule).then((response) => {
          resp = response.data
          if (resp === false) {
            this.blockDate(schedule.appointment_slot_id)
            this.time = {name: '', id: ''}
            this.submit = false
          }
        }).catch((error) => {
          console.log('error', error)
        })
      }
      if (!this.singlePage && resp && !token) {
        this.$emit('nextTab')
        return true
      }
      if (resp) {
        return schedule
      }
      this.validatedSectionClass = 'invalid-section-class'
      this.generalClass = 'general-invalid-section'
      return false
    },
    async chosenDate (prettyDate, value) {
      this.submit = false
      this.time = {name: '', id: ''}
      this.chosen = prettyDate
      this.selectedDate = value
      await this.checkCapacityAll()
    },
    checkDateAvailability (index) {
      let selectedDate = new Date(this.selectedDate)
      if (this.$store.state.site.schedule.data[index]['available_days'] === 'Week Days') {
        let dayOfWeek = selectedDate.getUTCDay()
        let isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0)
        return isWeekend
      }
      if (this.$store.state.site.schedule.data[index]['available_days'] === 'Weekends Only') {
        let dayOfWeek = selectedDate.getUTCDay()
        let isWeekend = (dayOfWeek === 6) || (dayOfWeek === 0)
        return !isWeekend
      }
      if (this.$store.state.site.schedule.data[index]['available_days'] === 'Custom') {
        let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        let dayOfWeek = days[selectedDate.getUTCDay()]
        const found = this.$store.state.site.schedule.data[index]['custom_days'].find((availableDay) => {
          return availableDay === dayOfWeek
        })
        return !found
      }
      return false
    },
    checkBlockedDate (index) {
      const isBlocked = this.$store.state.site.schedule.data[index]['blocked_days'].find((blockedDay) => {
        return blockedDay === this.selectedDate
      })
      return isBlocked
    },
    async checkCapacityAll () {
      // all intervals
      this.loading = true
      let scheduleObject = {dateSelected: this.selectedDate, schedules: this.$store.state.site.schedule.data}
      await axios.post(process.env.SERVER_URI + '/check_capacity/' + this.$store.state.sitecode, scheduleObject).then((response) => {
        this.$store.state.site.schedule.data = response.data
        this.loading = false
      }).catch((error) => {
        console.log('error', error)
        this.loading = false
      })
    },
    checkDisabledInterval (index) {
      return this.$store.state.site.schedule.data[index]['disabled']
    },
    blockDate (id) {
      this.$store.state.site.schedule.data = this.$store.state.site.schedule.data.map(schedule => {
        if (schedule.id === id) {
          return {...schedule, disabled: true}
        }
        return schedule
      })
    }
  },
  computed: {
    date_text_display () {
      if (this.time.name && this.selectedDate) {
        this.validatedSectionClass = 'validated-section-class'
        this.generalClass = 'general-inactive-section'
      } else {
        this.validatedSectionClass = 'invalid-section-class'
        this.generalClass = 'general-invalid-section'
      }
      if (!this.time.name) {
        return 'You chose ' + this.chosen
      }
      return 'You chose ' + this.chosen + ' at ' + this.time.name
    },
    formattedAddress  () {
      return this.siteAddress.replaceAll(' ', '%20')
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/sass/paper/_variables.scss';
.general-inactive-section {
  transition: 0.4s;
}
.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}
.schedule {
  display: flex;
  flex-direction: row;
}
.right-schedule {
  display: flex;
  flex-direction: column;
  max-height: 100%;
}
.chosenDate {
  font-weight: bold;
  margin-top: 10px;
}
.address {
  margin-top: auto;
  width: 250px;
  a {
    font-weight: 100;
    font-size: 13px;
    text-decoration: underline;
    color:$primary-color;
  }
}
@media only screen and (max-width: 980px) {
  .schedule {
    display: flex;
    flex-direction: column;
  }
  .right-schedule {
    padding-top:30px;
  }
  .right-schedule > br:not(:first-of-type){
    display: none;
  }
  .address {
    margin: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/ScheduleSection.vue